export default "__VITE_ASSET__CYVCWZGN__"